import { AddBusinessAdmin, BusinessAdmin, PermissionList } from '../../pages';
import { AdminController, EmployeeController, UserController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { adminStore, userStore } from '../../stores';
import React, { useState } from 'react';
import { toJS } from 'mobx';

const PermissionListContainer = ({ closeModal, data }) => {
	const [viewPermissions, setViewPermissions] = useState(-1);
	const [savePermissions, setSavePermissions] = useState(false);
	const [loading, setLoading] = useState(false);

	const showPermissions = i => {
		if (viewPermissions === i) {
			return setViewPermissions(-1);
		} else {
			setViewPermissions(i);
		}
	};

	const showSavedPermissions = () => {
		setSavePermissions(true);
	};

	const onSubmit = async (values) => {
		const payload = {
			permission: values.ids.map(x => (
				x._id
			))
		};
		if (payload?.permission?.length === 0) {
			return MimaToastUtil.error({
				message: 'Select Permissions to proceed',
			});
		}
		setLoading(true);
		const { status, errorMessage } = await AdminController.setAdminPermissions(payload, data._id);
		if (status === constant.Success) {
			setLoading(false);
			closeModal();
			MimaToastUtil.success({
				message: constant.Success,
			});
			await AdminController.getAdminUsers();
			return
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<PermissionList
			data={data}
			viewPermissions={viewPermissions}
			availablePermissions={toJS(adminStore.permissions)}
			admin={adminStore.admins.admins}
			showPermissions={showPermissions}
			savePermissions={savePermissions}
			showSavedPermissions={showSavedPermissions}
			closeModal={closeModal}
			onSubmit={onSubmit}
			loading={loading}
		/>
	);
};

export default PermissionListContainer;
